<template>
  <section class="modal-success">
    <div class="container">
      <div class="content">
        <img
          alt="complete"
          src="@/assets/thank-you.svg"
          width="160"
          height="181"
          title=""
        />
        <h2 class="h1">Siker!</h2>
        <p>
          Az adataidat sikeresen továbbítottuk. Hamarosan megkapod a letöltés
          linket.
        </p>
      </div>
      <div class="control">
        <!-- <Button
          :to="{ path: '/' }"
          @click="next(this, event)"
          arrow="right"
          class="black"
          >Vissza a főoldalra</Button
        > -->
      </div>
    </div>
  </section>
</template>

<script>
import Button from "@/components/inputs/Button.vue";

export default {
  name: "Success",
  components: {}
};
</script>

<style lang="scss">
.modal-success {
  padding: 64px 16px 16px;
  height: 100%;
  box-sizing: border-box;
  .container {
    height: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    justify-content: space-between;
    .content {
      text-align: center;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      align-items: center;
      justify-content: center;
      max-width: 415px;
      height: 100%;
      img {
        height: 180px;
        width: auto;
        margin-bottom: 24px;
      }
      p {
        height: 30%;
        margin-bottom: 16px;
      }
    }
    .control {
      .button {
        width: 100%;
      }
    }
  }

  @media screen and (min-width: $breakpoint) {
    padding: 64px 24px 24px;
    .container {
      align-items: center;
      .control {
        .button {
          width: auto;
        }
      }
      .content {
        max-width: none;
        p {
          max-width: 500px;
        }
      }
      .control {
        display: flex;
        justify-content: flex-end;
        width: 100%;
        .button {
        }
      }
    }
  }
}
</style>
